<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack" content="学员已兑换课程信息"></el-page-header>
			<el-divider></el-divider>
			<div class="row-me row-center" v-if="dataInfo != null">
				<el-descriptions title="学员基础信息" colon="true" style="width: 100%;" :column = "4" border>
					<el-descriptions-item label="头像">
						<el-image v-if="dataInfo.avatar == null" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
						<el-image v-else class="avatarBox" :src="dataInfo.avatar"></el-image>
					</el-descriptions-item>
				  	<el-descriptions-item label="生日">{{dataInfo.birthday}}</el-descriptions-item>
				  	<el-descriptions-item label="性别">{{dataInfo.sex}}</el-descriptions-item>
				  	<el-descriptions-item label="年龄">{{dataInfo.ageText}}岁</el-descriptions-item>
					
					<el-descriptions-item label="姓名">{{dataInfo.name}} </el-descriptions-item>
					<el-descriptions-item label="手机号">{{dataInfo.phone}}</el-descriptions-item>
					
					<el-descriptions-item label="昵称">{{dataInfo.nickname}}</el-descriptions-item>
					<el-descriptions-item label="年级">{{dataInfo.grade_text}}</el-descriptions-item>
					<el-descriptions-item label="地区">{{dataInfo.area_text}}</el-descriptions-item>
					<el-descriptions-item label="签名">{{dataInfo.signature}}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="column-me flex1 overflow-auto margin-top20">
				<div class="flex1 overflow-auto">
					<el-table 
						:data="tableData" 
						:highlight-current-row="false" 
						:show-header="false" 
						v-loading="loading" 
						empty-text="还未开通课程"
						size="medium" 
						style="width: 100%" 
						height="100%">
						<el-table-column prop="phone" label="课程图片" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-image v-if="scope.row.image == null" class="specialImgBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="specialImgBox" :src="scope.row.image"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="nickname" label="课程信息"  width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="specialTitle">{{scope.row.title}}</div>
								<div class="specialStudy"  v-if="scope.row.studyRecode != null">正在学习：{{scope.row.studyRecode.studyTaskRecord.specitalTaskInfo.title}}</div>
								<div class="specialStudy"  v-else>还未开始</div>
								<div class="startTimeBox"  v-if="scope.row.studyRecode != null">开始时间：{{scope.row.studyRecode.add_time}}</div>
								<div class="startTimeBox"  v-else>开始时间：还未开始</div>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="学习进度" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-progress v-if="scope.row.studyRecode != null" :percentage="scope.row.studyRecode.special_progress"></el-progress>
								<el-progress v-else :percentage="0"></el-progress>
							</template>
						</el-table-column>
						<el-table-column prop="sex" label="学习用时"  width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox"  v-if="scope.row.studyRecode != null">已学习时长：{{scope.row.studyRecode.special_current_time}}</div>
								<div class="startTimeBox"  v-else>已学习时长：还未开始</div>
								<div class="startTimeBox">课程总时长：{{scope.row.special_duration}}</div>
								<div class="startTimeBox">课时总数量：{{scope.row.classNumber}}</div>
							</template>
						</el-table-column>
						<el-table-column prop="sex" label="学习用时"  width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox">
									<el-button type="primary" @click="goStudentSpecialTaskList(scope.row.id,this.id)" size="small">进度详情</el-button>
								</div>
								<div v-if="acctype == 1" class="startTimeBox">
									<el-button type="danger" size="small" @click="refundClassBoxOpen(scope.row)">课时退费</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				
			</div>
		</div>
	</div>
	<el-dialog title="课时退费" v-model="refundClassBox" width="1200px" top="10vh" :destroy-on-close="true">
		<div class="row-me row-center" v-if="specialInfo != null">
			<el-descriptions title="课程信息" colon="true" style="width: 100%;" :column = "3" border>
				<el-descriptions-item label="名称">{{specialInfo.title}} </el-descriptions-item>
				<el-descriptions-item v-if="specialInfo.studyRecode != null" label="已学时长">{{specialInfo.studyRecode.special_current_time}} </el-descriptions-item>
				<el-descriptions-item v-else label="已学时长">00:00:00</el-descriptions-item>
				<el-descriptions-item label="总时长">{{specialInfo.special_duration}}</el-descriptions-item>
				<el-descriptions-item label="退费百分比">
					<el-progress  :percentage="refundInfo.special_progress"></el-progress>
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="row-me row-center" v-if="dataInfo != null">
			<el-descriptions title="学员信息" colon="true" style="width: 100%;" :column = "4" border>
				<el-descriptions-item label="昵称">{{dataInfo.nickname}} </el-descriptions-item>
				<el-descriptions-item label="姓名">{{dataInfo.name}} </el-descriptions-item>
				<el-descriptions-item label="手机号">{{dataInfo.phone}}</el-descriptions-item>
				<el-descriptions-item label="地区">{{dataInfo.area_text}}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="row-me row-center margin-top20" v-if="agentInfo != null">
			<el-descriptions title="代理信息" colon="true" style="width: 100%;" :column = "4" border>
				<el-descriptions-item label="代理">{{agentInfo.lecturer_name}} </el-descriptions-item>
				<el-descriptions-item label="联系人">{{agentInfo.username}} </el-descriptions-item>
				<el-descriptions-item label="手机号">{{agentInfo.phone}}</el-descriptions-item>
				<el-descriptions-item label="地区">{{agentInfo.region_text}}</el-descriptions-item>
			</el-descriptions>
		</div>
		<el-divider content-position="left">退费备注说明</el-divider>
		<div class="row-me row-center margin-top20">
			<el-input
				class="width100Per"
				type="textarea"
				:rows="5"
				placeholder="请输入内容"
				v-model="refundInfo.remark">
			</el-input>
		</div>
		<div class="row-me flex-end1 margin-top20">
			<el-button @click="refundClassBoxClosed()">取消</el-button>
			<el-button @click="refundClassHoursSave()" type="primary">保存</el-button>
		</div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
  components: {Plus,Search},
  data() {
    return {
		acctype:null,
		id:0,
		dataInfo:null,
		loading:true,
		tableData: [],
		refundClassBox:false,
		agentInfo:null,
		specialInfo:null,
		refundInfo:{
			user_id:0,
			special_id:0,
			agent_id:0,
			special_progress:0,
			remark:''
		},
		
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
	  this.acctype = sessionStorage.getItem('acctype');
  },
  // html加载完成后执行。
  mounted() {
	this.id = this.$route.query.id;
	if(this.id != 0){
		this.getStudentInfo();
		this.getData();
	}
	console.log(this.id);
  },
  // 事件方法执行
	methods: {
		goBack(){
		  this.$router.go(-1)
		},
		//跳转课时详情
		goStudentSpecialTaskList(obj,user_id){
			this.$router.push({
				name:'studentSpecialTaskList',
				query:{
					id:obj,
					user_id:user_id
				}
			})
		},
		//table获取用户兑换课程数据
		getData() {
			this.loading = true;
			this.$post('/admin/userSpecialList', {
				id: this.id,
			}).then((res) => {
				if (res) {
					console.log(res.data);
					this.tableData = res.data;
					this.loading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		getStudentInfo(){
			this.$post('/admin/studentInfo', {
				id: this.id
			}).then((res) => {
				if (res) {
					console.log(res.data);
					this.dataInfo = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//============================课时退费==============================
		refundClassHoursSave(){
			this.refundInfo.user_id = Number(this.dataInfo.id);
			this.refundInfo.special_id = this.specialInfo.id;
			this.refundInfo.agent_id = this.agentInfo.id;
			if(this.refundInfo.remark == ''){
				this.$message.warning('请填写退费备注说明');
				return;
			}
			this.$post('/admin/refundClassHours', this.refundInfo).then((res) => {
				if (res) {
					this.$message.success('保存成功');
					this.refundInfo = {
						user_id:0,
						special_id:0,
						agent_id:0,
						special_progress:0,
						remark:''
					};
					this.refundClassBoxClosed();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		refundClassBoxOpen(obj){
			this.specialInfo = obj;
			if(this.specialInfo.studyRecode != null){
				this.refundInfo.special_progress = 100 - this.specialInfo.studyRecode.special_progress;
			}else{
				this.refundInfo.special_progress = 100;
			}
			this.getAgentInfo();
			this.refundClassBox = true;
		},
		refundClassBoxClosed(){
			this.refundClassBox = false;
		},
		getAgentInfo(){
			this.$post('/admin/agentInfo', {
				id: this.dataInfo.agent_user_id
			}).then((res) => {
				if (res) {
					console.log(res.data);
					this.agentInfo = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.userList {
	height: 100%;
	.avatarBox{
		width: 40px;
		height: 40px;
		border-radius: 20px;
		overflow: hidden;
	}
	.specialTitle{
		float: left;
		width: 100%;
		height: 40px;
		text-align: left;
		line-height: 40px;
		font-size: 18px;
		color: #555555;
		// background-color: aquamarine;
	}
	.specialStudy{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 16px;
		color: #555555;
		// background-color: antiquewhite;
	}
	.startTimeBox{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 14px;
		color: #555555;
		// background-color: aquamarine;
	}
	.stemTitle{
		//float: left;
		width: 100% !important;
		font-size: 14px;
		font-weight: bold;
		height: 40px;
		overflow: hidden;
		line-height: 40px;
	}
	.stemClass{
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		height: auto;
		overflow: hidden;
		color: #000000;
		span{
			float: left;
		}
		.setmImage{
			float: left;
			//margin-left: calc(50% - 180px);
			width: 80%;
			height: 225px;
			overflow: hidden;
		}
		.optionClass{
			display: block;
			font-size: 14px;
			font-weight: 500;
			line-height: 30px;
			height: auto;
			width: 100%;
			padding: 0px 10px 0px 0px;
			.optionImageTitle{
				float: left;
				width: 30px;
				line-height: 225px;
				height: 225px;
			}
			
		}
	}
	.stemClass .optionClass .optionImage{
				float: left;
				width: 360px;
				height: 225px;
			}
	.stemClass .optionClass .optionImage .el-image{
		width: 360px;
		height: 225px;
		overflow: hidden;
	}	
	.setmAnswer{
		font-size: 14px;
		line-height: 40px;
		background-color: #f4f4f5;
		color: #909399;
		padding: 0px 20px 0px 20px;
	}
	.setmBrief{
		float: left;
		width: 100%;
		overflow: hidden;
	}
	.setmBrief img{
		width: 500px;
		height: auto;
	}
	
	
	
}
</style>
